import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Module, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(private httpClient: HttpClient) { }

  getModules(): Observable<Response<Module[]>> {
    return this.httpClient.get<Response<Module[]>>(environment.apiPath + 'Module');
  }

  getModulesByUserId(id: number): Observable<Response<Module[]>> {
    return this.httpClient.get<Response<Module[]>>(environment.apiPath + 'Module/' + id + '/UserId');
  }
}
